module.exports = __webpack_public_path__ + "static/media/Myres.ba403bbe.png";